import React, { useLayoutEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
    Input,
    FormControl,
    FormLabel,
    useColorModeValue,
    useDisclosure,
} from "@chakra-ui/react";
import { FilterContainer } from "../../../components/Tables/FilterContainer";
import { formatDocument } from "utils/utils";

export const PersonFilter = (props) => {
    const { t } = useTranslation('common');
    const { onFilter, filterSnapshot } = props;
    const { isOpen, onToggle } = useDisclosure();
    const [cpfCnpj, setCpfCnpj] = useState("");
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const placeholderColor = useColorModeValue("gray.300", "gray.400");

    const onFilterHandler = () => {
        onFilter({
            cpfCnpj: cpfCnpj,
            name: name,
            email: email,
        });
    }

    const onClearHandler = () => {
        setCpfCnpj("");
        setName("");
        setEmail("");

        onFilter({ cpfCnpj: null, name: null, email: null });
    }

    useLayoutEffect(() => {
        if (filterSnapshot == null) {
            setCpfCnpj("");
            setName("");
            setEmail("");
            return;
        }
        setCpfCnpj(filterSnapshot.cpfCnpj ? formatDocument(String(filterSnapshot.cpfCnpj)) : "");
        setName(filterSnapshot.name ? String(filterSnapshot.name) : "");
        setEmail(filterSnapshot.email ? String(filterSnapshot.email) : "");
    }, [filterSnapshot]);

    return (
        <FilterContainer
            w='125px'
            fontSize='sm'
            fontWeight='bold'
            variant="light"
            isOpen={isOpen}
            onToggle={onToggle}
            onFilter={onFilterHandler}
            onClear={onClearHandler}
        >
            <FormControl>
                <FormLabel>
                    {t("settings.person.filters.cpf-cnpj.label")}
                </FormLabel>
                <Input
                    fontSize="sm"
                    placeholder={t("settings.person.filters.cpf-cnpj.placeholder")}
                    _placeholder={{ color: placeholderColor, fontSize: "sm" }}
                    value={cpfCnpj}
                    onChange={e => {
                        const formatted = formatDocument(e.currentTarget.value);
                        setCpfCnpj(formatted);
                    }}
                />
            </FormControl>

            <FormControl>
                <FormLabel>
                    {t("settings.person.filters.name.label")}
                </FormLabel>
                <Input
                    fontSize="sm"
                    placeholder={t("settings.person.filters.name.placeholder")}
                    _placeholder={{ color: placeholderColor, fontSize: "sm" }}
                    value={name}
                    onChange={e => setName(e.currentTarget.value)} />
            </FormControl>

            <FormControl>
                <FormLabel>
                    {t("settings.person.filters.email.label")}
                </FormLabel>
                <Input
                    fontSize="sm"
                    placeholder={t("settings.person.filters.email.placeholder")}
                    _placeholder={{ color: placeholderColor, fontSize: "sm" }}
                    value={email}
                    onChange={e => setEmail(e.currentTarget.value)} />
            </FormControl>
        </FilterContainer>
    );
};